import React from "react";
import {url} from "../utils/UrlsUtil";
import "../../style/common/footer/_footer.scss";
import {Image} from "react-bootstrap";
import {Link} from "react-router-dom";
const Footer:React.FC = ({}) => {
  return (
      <div id="pageFooter" className="row gx-0">
          <div className="col-12">
              <div className="footer-contents">
                  <div><Image src={url('images/logo/geeva_logo.png')} fluid={true}></Image></div>
                  <ul className="foot-subnav">
                      <li className="foot-subnav_item"><Link to="/company">会社概要</Link></li>
                      <li className="foot-subnav_item"><Link to="/policy">ご利用規約</Link></li>
                      <li className="foot-subnav_item"><Link to="/help">特定商取引法に基づく表示</Link></li>
                      <li className="foot-subnav_item"><Link to="/use">ご利用方法</Link></li>
                  </ul>
                  <div className="contact">お問い合わせは<a href="mailto:customer@seibo.gift">こちら</a>からお送りください。</div>
                  <p className="copyright">©Copyright geeva All Right Reserved.</p>
              </div>

          </div>
      </div>
  );
};
export default Footer;